import { createAsyncThunk } from '@reduxjs/toolkit';
import {  _studyDataUrls } from '@custom/Utils/constants/apiUrls';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

const studyData = createAsyncThunk('studyData', async () => {
  try {
    let url = `${_studyDataUrls.get}`
    const pacs_token = getCloudPACSToken();
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${pacs_token}`,

      },
    })
    if(response.status === 200){
      return await response.json()
    }
  } catch (error) {
    return error;
  }
});

export default studyData;
